// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.navbar-logo {
  height: 44px;
  width: auto;
  object-fit: contain;
}

.brand-text {
  font-weight: 600;
  font-size: 1rem;
}`, "",{"version":3,"sources":["webpack://./src/components/css/TopNavbar.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB","sourcesContent":[".navbar-logo {\r\n  height: 44px;\r\n  width: auto;\r\n  object-fit: contain;\r\n}\r\n\r\n.brand-text {\r\n  font-weight: 600;\r\n  font-size: 1rem;\r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
